import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Alert } from "../../model/alert/alert.model";
import { IQueryFilter, QueryResult } from "../../model/query.filter.class";
import { createUrl, queryToParams } from "../api.util";
import { GenericApi, HasIdOrExternalValueOrExternalIdOrServiceName } from "../generic.api";

// Convenience Type
type T = Alert;
type I = Alert;

@Injectable({
  providedIn: "root",
})
export class AlertApi extends GenericApi<T> {
  public path = "alert";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  get = (id: number): Observable<T & HasIdOrExternalValueOrExternalIdOrServiceName<string>> => {
    return this.httpClient.get<T & HasIdOrExternalValueOrExternalIdOrServiceName<string>>(
      createUrl(this.path, id),
    );
  };

  list = (
    query: IQueryFilter,
  ): Observable<QueryResult<T & HasIdOrExternalValueOrExternalIdOrServiceName<string>>> => {
    return this.httpClient.get<
      QueryResult<T & HasIdOrExternalValueOrExternalIdOrServiceName<string>>
    >(createUrl(this.path), {
      params: queryToParams(query),
    });
  };

  resolveScannedResponseAlert = (
    alertId: number,
    formInstanceId?: number,
  ): Observable<{ success: boolean,newAlertId: number|undefined  }> => {
    return this.httpClient.post<{ success: boolean, newAlertId: number|undefined }>(
      createUrl(this.path, "resolve-scanned-response-alert"),
      {
        alertId,
        formInstanceId,
      },
    );
  };

  retrieveScannedResponseImage = (alertId: number): Observable<string> => {
    return this.httpClient.get<string>(
      createUrl(this.path, "retrieve-scanned-response-image", alertId),
    );
  };
}
